import React from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { TitleFormattedMessage } from '../../components/titleFormattedMessage';
import PropdocsModal from '../../components/modal/PropdocsModal';

type WordExportToggleModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDisabled: boolean;
  templateName: string;
};

const WordExportToggleModal: React.FC<WordExportToggleModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDisabled,
  templateName,
}) => {
  const title = isDisabled ? 'Enable Word Export' : 'Disable Word Export';
  const message = isDisabled
    ? `Documents created from "${templateName}" will be able to export to Word format. This setting will only affect new documents created after this change.`
    : `Documents created from "${templateName}" will not have the ability to export to Word format. This setting will only affect new documents created after this change.`;
  const buttonText = isDisabled ? 'Enable Word Export' : 'Disable Word Export';

  return (
    <PropdocsModal
      show={isOpen}
      setShow={onClose}
      size="sm"
      title={<FormattedMessage id={`title.${isDisabled ? 'enable' : 'disable'}-word-export`} defaultMessage={title} />}
    >
      <>
        <div style={{ marginBottom: '1.5rem' }}>
          <p>{message}</p>
          <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>
            <FormattedMessage id="confirm.continue-question" defaultMessage="Do you want to continue?" />
          </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <Button variant="link" className="text-secondary" onClick={onClose}>
            <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            <TitleFormattedMessage
              id={`cta.${isDisabled ? 'enable' : 'disable'}-word-export`}
              defaultMessage={buttonText}
            />
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default WordExportToggleModal;
